import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App";

// Create the router configuration

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = createRoot(rootElement);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
